import { Component, Input } from '@angular/core';
import { LineChartOptions } from '../charts.model';

interface TooltipSeriesItem {
  series: string;
}

@Component({
    selector: 'ifb-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.scss'],
    standalone: false
})
export class LineChartComponent {

  @Input()
  options: LineChartOptions;

  @Input()
  view: string[];

  @Input()
  data: any;

  constructor() { }

  trackByTooltipSeries(_index: number, item: TooltipSeriesItem): string {
    return item.series;
  }

}
